// src/components/Loader.js
import React from 'react';
import '../App.css';

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;